module.exports = __webpack_public_path__ + "static/08-7ea17e97e75ba8cbbde28f60098fb0dd.jpg";